import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';

import { Box, Container, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Greeting from '../../components/Greeting';
import AvailableDateCard from '../../components/AvailableDateCard';

import RouterStore from '../../stores/RouterStore';

const successfullyScheduledStyles = {
  boxSelectedDate: {
    maxWidth: '194px',
    margin: '0 auto',
  },
  boxText: {
    maxWidth: '480px',
    margin: '24px auto 40px auto',
    '& p': {
      fontSize: '16px',
    },
  },
  boxAlert: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 8px',
    width: '100%',
    background: '#e8f4fd',
    borderRadius: '4px',
    marginBottom: '16px',
    '& svg': {
      marginRight: '8px',
    },
  },
};

class SuccessfullyScheduled extends Component {
  state = {
    customerName: '',
    scheduledDate: '',
  };

  async componentDidMount() {
    const { routerStore } = this.props;
    const {
      location: { state },
    } = routerStore;

    const { customer, scheduledDate } = toJS(state);

    this.setState({
      customerName: customer.name,
      scheduledDate,
    });
  }

  render() {
    const { classes } = this.props;
    const { customerName, scheduledDate } = this.state;

    return (
      <>
        <Box mt={5} mb={12}>
          <Container>
            <Greeting name={customerName} />
            <Box mt={5} mb={3} textAlign="center">
              <Typography component="div">
                <Box fontSize={42} fontWeight="bold" mb={3}>
                  Anote a data!
                </Box>
              </Typography>
              {scheduledDate && (
                <Box className={classes.boxSelectedDate}>
                  <AvailableDateCard date={scheduledDate} selected withCheck />
                </Box>
              )}
              <Typography component="div">
                <Box fontSize={42} fontWeight="bold" mt={5}>
                  Montagem agendada com sucesso.
                </Box>
              </Typography>
              <Box className={classes.boxText}>
                <Typography>
                  Sua montagem será realizada na data agendada no período
                  comercial
                </Typography>
                <br />
                <Typography>
                  <strong>Importante:</strong>
                  <br />
                  O lugar onde seu produto será montado precisa estar livre, tá?
                  <br />
                  Ah, e é necessário uma pessoa maior de 18 anos para acompanhar
                  o montador.
                </Typography>
                <br />
                <Box className={classes.boxAlert}>
                  <Typography>
                    Em breve você receberá uma mensagem no seu WhatsApp com o
                    link para acompanhar seu agendamento.
                  </Typography>
                </Box>
                <Typography>
                  <strong>
                    Muito obrigada por agendar sua montagem com a gente
                  </strong>{' '}
                  ❤️
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
      </>
    );
  }
}

SuccessfullyScheduled.propTypes = {
  classes: PropTypes.object.isRequired,
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default withStyles(successfullyScheduledStyles)(
  inject('routerStore')(observer(SuccessfullyScheduled))
);
